import React from "react";
import { Link } from "react-router-dom";
import { FormGroup, InputGroup, Callout, Intent } from "@blueprintjs/core";
import { Icon } from "../../../atoms/Icon";
import { AccountForm } from "../../../molecules/AccountForms";
import { isEmail } from "validator";

import styles from "./RegisterForm.module.scss";

function RegisterForm({
  firstName,
  lastName,
  username,
  email,
  password,
  savedFirstName,
  savedLastName,
  savedEmail,
  savedUsername,
  invalidPassword,
  error,
  setFirstName,
  setLastName,
  setEmail,
  setPassword,
  createAccount,
  mutationLoading,
  showPassword,
  setShowPassword,
  onUsernameChange,
  invalidUsername,
  invalidEmail,
  isFormValid,
  disabled
}) {
  return (
    <AccountForm
      className={styles.register}
      onboardingHeaderText={true}
      fullButton={true}
      onSubmit={createAccount}
      headerText="Personal Info"
      buttonText="Next"
      disabled={disabled}
      mutationLoading={mutationLoading}
    >
      {error && (
        <Callout
          intent={Intent.WARNING}
          title={error.title}
          style={{ marginBottom: "1em" }}
          icon={null}
        >
          {(error.code === "user_exists" ||
            error.code === "username_exists") && (
            <p>
              {error.message}{" "}
              <Link to="/login">
                <b>Here</b>
              </Link>
            </p>
          )}
          {error.code !== "user_exists" && error.code !== "username_exists" && (
            <p>{error.message}</p>
          )}
        </Callout>
      )}

      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup label="FIRST NAME" labelFor="first-name">
            <InputGroup
              id="first-name"
              type="text"
              intent={!isFormValid && !firstName ? Intent.DANGER : Intent.NONE}
              value={
                firstName || firstName === "" ? firstName : savedFirstName || ""
              }
              onChange={setFirstName}
              placeholder={savedEmail ? "" : "John"}
            />
          </FormGroup>
        </div>

        <div className={styles.column}>
          <FormGroup label="LAST NAME" labelFor="last-name">
            <InputGroup
              id="last-name"
              type="text"
              intent={!isFormValid && !lastName ? Intent.DANGER : Intent.NONE}
              value={
                lastName || lastName === "" ? lastName : savedLastName || ""
              }
              onChange={setLastName}
              placeholder={savedEmail ? "" : "Smith"}
            />
          </FormGroup>
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup label="EMAIL" labelFor="email">
            <InputGroup
              id="email"
              type="email"
              value={savedEmail || email}
              intent={
                !isFormValid && (!email || invalidEmail) && !savedEmail
                  ? Intent.DANGER
                  : Intent.NONE
              }
              onChange={setEmail}
              disabled={savedEmail}
              placeholder={"someone@email.com"}
            />
          </FormGroup>
          {!isFormValid && invalidEmail && (
            <p className={styles.errorMessage}>Invalid email address.</p>
          )}
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup label="USER NAME" labelFor="username">
            <InputGroup
              id="username"
              type="text"
              autoComplete="false"
              autoCapitalize="none"
              value={savedUsername || username}
              intent={
                !isFormValid && (!username || invalidUsername) && !savedUsername
                  ? Intent.DANGER
                  : Intent.NONE
              }
              onChange={onUsernameChange}
              disabled={savedUsername}
              placeholder={"john.smith"}
            />
          </FormGroup>

          {!isFormValid && invalidUsername && (
            <p className={styles.errorMessage}>Username can not be an email.</p>
          )}
        </div>
        <div className={styles.column}>
          <FormGroup label="PASSWORD" labelFor="password-input">
            <InputGroup
              id="password-input"
              value={savedUsername ? "bad-treefrog" : password}
              type={showPassword ? "text" : "password"}
              onChange={setPassword}
              disabled={savedUsername}
              placeholder={"***********"}
              intent={
                !isFormValid && (!password || invalidPassword) && !savedUsername
                  ? Intent.DANGER
                  : Intent.NONE
              }
              rightElement={
                <Icon
                  name="eye-open"
                  color="#adbdcb"
                  className={styles.viewBtn}
                  onClick={() => {
                    !savedUsername && setShowPassword(!showPassword);
                  }}
                />
              }
            />
          </FormGroup>

          {!isFormValid && invalidPassword && (
            <p className={styles.errorMessage}>
              Password must contain at least 9 characters, contain 1 lowercase,
              1 uppercase letter and a number.
            </p>
          )}
        </div>
      </div>
    </AccountForm>
  );
}

export default RegisterForm;
